import { TextField, TextFieldProps, styled } from "@mui/material";
import { grey } from "@mui/material/colors";

const BaseTextInput = styled(TextField)<TextFieldProps>(({ theme }) => ({
    "& label.Mui-focused": { color: theme.palette.text.primary },
    "& .MuiOutlinedInput-root": {
        "&:hover fieldset": { borderColor: grey[500], },
        "&.Mui-focused fieldset": { borderColor: grey[400] },
    },
}));

export default BaseTextInput;